module.exports = __webpack_public_path__ + "img/suggestion.2fa31035.svg";